// extracted by mini-css-extract-plugin
module.exports = {"label":"datafilterdaterangebox_label__37bzO","btnCalendar":"datafilterdaterangebox_btnCalendar__R1Mkw","calendarBox":"datafilterdaterangebox_calendarBox__1LejQ"};